import React from "react";
import {TextField} from "@mui/material";
import {BoolFilterField, UserField} from "@atttomyx/react-components";
import {forms, objects} from "@atttomyx/shared-utils";
import {UNANSWERED} from "../../constants";

const HelpFilters = (props) => {
    const { data, onChange : onSync, formProps } = props;
    const { user, users, userId } = formProps;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="help-filters">
        {user.roles.admin && userId === UNANSWERED ? <div className="field">
            <UserField
                users={users}
                value={data.userId}
                onChange={(userId) => onChange("userId", userId)}
            />
        </div> : null}
        <div className="field">
            <TextField label="Question"
                       type="text"
                       value={forms.sanitizeValue(data.question)}
                       onChange={(event) => onChange("question", event.target.value)}
            />
        </div>
        {!user.roles.admin || userId !== UNANSWERED ? <div className="field">
            <BoolFilterField label="Answered"
                             value={forms.sanitizeValue(data.answer)}
                             onChange={(value) => onChange("answer", value)}
            />
        </div> : null}
    </div>
}

export default HelpFilters;
